import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home.vue'
import Kontakt from '@/views/Kontakt.vue'
import Winterdienst from '@/components/leistungen/Winterdienst.vue'
import Leistungen from '@/views/Leistungen.vue'
import About from '@/views/About.vue'
import Gebaudemanagement from '@/components/leistungen/Gebaudemanagement.vue'
import Hausmeisterdienst from '@/components/leistungen/Hausmeisterdienst.vue'
import Garten from '@/components/leistungen/Garten.vue'
import Referenzen from '@/views/Referenzen.vue'
import Gebaeudereinigung from '@/components/leistungen/Gebaeudereinigung.vue'
import Industriereinigung from '@/components/leistungen/Industriereinigung.vue'
import Angebot from '@/views/Angebot.vue'
import Impressum from '@/views/Impressum.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  linkActiveClass: 'active',
  scrollBehavior(to, from, savedPosition) {
    if (
      from.matched.some(record => record.meta.noScroll) &&
      to.matched.some(record => record.meta.noScroll)
    )
      return new Promise((resolve, reject) => {
        if (savedPosition) {
          resolve(savedPosition)
        } else {
          resolve()
        }
      })
    else
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          if (savedPosition) {
            resolve(savedPosition)
          } else {
            resolve({ x: 0, y: 0 })
          }
        }, 600)
      })
  },
  routes: [
    {
      path: '*',
      redirect: '/'
    },
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/kontakt',
      name: 'kontakt',
      component: Kontakt
    },
    {
      path: '/angebot-anfordern',
      name: 'angebot',
      component: Angebot
    },
    {
      path: '/ueber-uns',
      name: 'about',
      component: About
    },
    {
      path: '/leistungen',
      name: 'leistungen',
      component: Leistungen,
      redirect: '/leistungen/gebaeudereinigung',
      children: [
        {
          path: 'gebaeudemanagement',
          name: 'gebaeudemanagement',
          component: Gebaudemanagement,
          meta: { noScroll: true }
        },
        {
          path: 'hausmeisterservice',
          name: 'hausmeisterdienst',
          component: Hausmeisterdienst,
          meta: { noScroll: true }
        },
        {
          path: 'gebaeudereinigung',
          name: 'gebaeudereinigung',
          component: Gebaeudereinigung,
          meta: { noScroll: true }
        },
        {
          path: 'industriereinigung',
          name: 'industriereinigung',
          component: Industriereinigung,
          meta: { noScroll: true }
        },
        {
          path: 'gartenpflege',
          name: 'garten',
          component: Garten,
          meta: { noScroll: true }
        },
        {
          path: 'winterdienst',
          name: 'winterdienst',
          component: Winterdienst,
          meta: { noScroll: true }
        }
      ]
    },
    {
      path: '/referenzen',
      name: 'referenzen',
      component: Referenzen
    },
    {
      path: '/impressum-datenschutz',
      name: 'dsgvo',
      component: Impressum
    }
  ]
})
